export { default } from './cart-widget.component';
